import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ClientService } from 'src/app/shared/services/client.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  @Input() showHeader: boolean = true;
  model: any = {};
  loading = false;
  returnUrl: string;
  client: any = {};
  errors: string;
  userId: string;
  loginBoxTopStyle: any = {};
  loginBoxBottomStyle: any = {};
  loginBoxButtonStyle: any = {};

  // show/hide password fields
  showCurrentPasswordEye: boolean = false;
  showCurrentPassword: boolean = false;
  showNewPasswordEye: boolean = false;
  showNewPassword: boolean = false;
  showConfirmNewPasswordEye: boolean = false;
  showConfirmNewPassword: boolean = false;

  constructor(private authService: AuthService,
              private clientService: ClientService,
              private router: Router) 
   {
        this.client = this.clientService.getClient();
        this.clientService.getUpdatedClient().subscribe(data => {
        this.client = data;
        });
   }

  ngOnInit() {
    try {
      this.loginBoxTopStyle = JSON.parse(this.client.clientSetting.siteSetting.loginPage.loginBoxTopStyle || {});
      this.loginBoxBottomStyle = JSON.parse(this.client.clientSetting.siteSetting.loginPage.loginBoxBottomStyle || {});
      this.loginBoxButtonStyle = JSON.parse(this.client.clientSetting.siteSetting.loginPage.loginBoxButtonStyle || {});
    }
    catch (e) {

    }
  }

  changePassword() {
    this.loading = true;
    if (this.model.newPassword != this.model.newConfirmPassword) {
      this.errors = "Password does not match with confirm password";
      this.loading = false;
      return;
    }
    this.userId = localStorage.getItem("UserID");
    this.authService.changePassword(this.model.currentPassword, this.model.newPassword, this.userId)
      .subscribe(
      data => {
        this.loading = false;
        Swal.fire({
          text: "Password has been changed successfully. Please login with your new password.",
          showCancelButton: false,
          allowOutsideClick: false
        }).then((result) => {
          if (result.value === true) {

            this.router.navigate(["auth/login"]);
          }
        });
      },
      error => {
        // this.alertService.error(error);
        this.loading = false;
        this.errors = error;
      });
  }

  // To Show/Hide Current Password
  onShowCurrentPassword() {
    this.showCurrentPasswordEye = !this.showCurrentPasswordEye;
    this.showCurrentPassword = !this.showCurrentPassword;
  }

  // To Show/Hide New Password
  onShowNewPassword() {
    this.showNewPasswordEye = !this.showNewPasswordEye;
    this.showNewPassword = !this.showNewPassword;
  }

  // To Show/Hide Confirm New Password
  onShowConfirmNewPassword() {
    this.showConfirmNewPasswordEye = !this.showConfirmNewPasswordEye;
    this.showConfirmNewPassword = !this.showConfirmNewPassword;
  }

}
